// Configuração das permissões da aplicação
export const PERMISSIONS = {
  admin: [
    'manage_users',
    'view_apis',
    'manage_settings',
    'view_dashboard',
    'search_data',
    'create_cobranca',
    'manage_reprocess'
  ],
  
  manager: [
    'view_apis',
    'search_data',
    'create_cobranca'
  ],
  
  user: [
    'search_data',
    'create_cobranca'
  ]
};

// Função para verificar se um usuário tem uma permissão específica
export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;
  
  const userPermissions = PERMISSIONS[userRole] || [];
  return userPermissions.includes(permission);
};

